/**
 * Maps the optional `canonical*` fields captured by {@link AddressAutocomplete}
 * onto the create/update contact request's
 * `canonicalAddress*` fields.
 *
 * Kept in one place so every quick-create site wires canonical identically —
 * the canonical value feeds the dedup waterfall's tier-3 match and NEVER
 * overwrites the filing address. Returns an empty object when the treasurer
 * typed the address by hand (no Mapbox pick), so the request simply omits the
 * canonical fields.
 */
export interface CanonicalFieldSource {
  canonicalAddressLine1?: string | null;
  canonicalAddressLine2?: string | null;
  canonicalCity?: string | null;
  canonicalState?: string | null;
  canonicalZip?: string | null;
}

export interface CanonicalRequestFields {
  canonicalAddressLine1?: string | null;
  canonicalAddressLine2?: string | null;
  canonicalCity?: string | null;
  canonicalState?: string | null;
  canonicalZip?: string | null;
}

export function canonicalAddressRequestFields(
  source: CanonicalFieldSource,
): CanonicalRequestFields {
  // No Mapbox pick (or it was cleared by a hand-edit) → omit entirely.
  if (!source.canonicalAddressLine1) return {};
  return {
    canonicalAddressLine1: source.canonicalAddressLine1,
    canonicalAddressLine2: source.canonicalAddressLine2 ?? null,
    canonicalCity: source.canonicalCity ?? null,
    canonicalState: source.canonicalState ?? null,
    canonicalZip: source.canonicalZip ?? null,
  };
}
